"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateCustomersTableConf = void 0;
var FooterCounterWithWord_1 = __importDefault(require("containers/TableMaker/components/FooterCounterWithWord"));
var constants_1 = require("containers/TableMaker/constants");
var populatedDerived_1 = require("utils/selectors/populatedDerived");
var AddressEditFields_1 = __importDefault(require("./CellComponents/AddressEditFields"));
var CountrySelect_1 = __importDefault(require("./CellComponents/CountrySelect"));
var MatchLevel_1 = __importDefault(require("./CellComponents/MatchLevel"));
var Status_1 = __importDefault(require("./CellComponents/Status"));
var StripeMigratedCustomerCell_1 = __importDefault(require("./CellComponents/StripeMigratedCustomerCell"));
var // XL, LG, MD, SM, XS,
XL = constants_1.CellSize.XL, LG = constants_1.CellSize.LG, MD = constants_1.CellSize.MD, XS = constants_1.CellSize.XS;
exports.migrateCustomersTableConf = {
    headersMap: {
        name: 'Customer',
        'stripeMigratedCustomer.name': 'Migrated customer',
        stripeMigrationMatchLevel: 'Match',
        'address.country': 'Country',
        'address.line1': 'Address line 1',
        'address.line2': 'Address line 2',
        'address.city': 'City',
        'address.state': 'State',
        'address.postalCode': 'Post code',
        stripeMigrationMapConfirmedOn: 'Status',
    },
    headerTooltip: {
        matchLevel: {
            description: '**Match** indicates how closely the customer name matches the Stripe name',
        },
    },
    config: {
        selector: populatedDerived_1.selectCustomersToMapToStripe,
        defaultSort: { key: 'name', order: 1 },
        batchSize: 50,
    },
    sortMapper: {
        stripeMigrationMatchLevel: Object.fromEntries(['multiple', 'notFound', 'weak', 'similar', 'strong', 'exact'].map(function (v, i) { return [v, i]; })),
    },
    layout: {
        fullWidth: true,
    },
    extractors: {},
    cells: [
        {
            cell: { width: XL, growCell: true, offset: 'left' },
            field: 'name',
            truncate: {},
            footerAggregate: 'count',
            footerAggregateRenderValue: (0, FooterCounterWithWord_1.default)('customer'),
        },
        {
            cell: { width: XL, isFlexCenter: true },
            field: 'stripeMigratedCustomer.name',
            footerAggregate: 'countUniq',
            renderComponent: StripeMigratedCustomerCell_1.default,
            // footerAggregateRenderValue: makeFooterCounterWithWord('customer'),
            stopPropagation: true,
        },
        {
            cell: { width: MD + XS }, field: 'stripeMigrationMatchLevel', defaultOrder: -1, renderComponent: MatchLevel_1.default,
        },
        {
            cell: { width: MD + XS + 20, isFlexCenter: true },
            field: 'address.country',
            defaultOrder: -1,
            renderComponent: CountrySelect_1.default,
            stopPropagation: true,
        },
        {
            cell: { width: XL, isFlexCenter: true },
            field: 'address.line1',
            defaultOrder: -1,
            renderComponent: (0, AddressEditFields_1.default)('line1'),
        },
        {
            cell: { width: MD + XS, isFlexCenter: true },
            field: 'address.line2',
            defaultOrder: -1,
            renderComponent: (0, AddressEditFields_1.default)('line2'),
        },
        {
            cell: { width: MD + XS, isFlexCenter: true },
            field: 'address.city',
            defaultOrder: -1,
            renderComponent: (0, AddressEditFields_1.default)('city'),
        },
        {
            cell: { width: MD + XS, isFlexCenter: true },
            field: 'address.state',
            defaultOrder: -1,
            renderComponent: (0, AddressEditFields_1.default)('state'),
        },
        {
            cell: { width: MD, isFlexCenter: true },
            field: 'address.postalCode',
            defaultOrder: -1,
            renderComponent: (0, AddressEditFields_1.default)('postalCode'),
        },
        // { cell: { width: XL + XS, growCell: true }, fields: ['primaryContactName', 'primaryContactEmail'] },
        {
            cell: { width: LG, isFlexCenter: true },
            field: 'stripeMigrationMapConfirmedOn',
            renderComponent: Status_1.default,
            footerAggregate: 'countNonEmpty',
            stopPropagation: true,
        },
    ],
};
